module.exports = __webpack_public_path__ + "static/unity-6736623f6c0ef41fe4bdb601abd9cd69.svg";